import React from 'react';
import Page from '../../components/Page';
import { Truck } from 'lucide-react';

const CTEsOverviewPage: React.FC = () => {
  return (
    <Page
      title="🚛 CTEs - Visão Geral"
      subtitle="Dashboard principal dos Conhecimentos de Transporte Eletrônico"
      onRefresh={() => window.location.reload()}
    >
      <div className="w-full h-full flex items-center justify-center">
        <div className="text-center">
          <Truck 
            className="h-16 w-16 mx-auto mb-4" 
            style={{ color: 'var(--primary)' }}
          />
          <h2 
            className="text-2xl font-semibold mb-2"
            style={{ color: 'var(--text-primary)' }}
          >
            CTEs - Em Desenvolvimento
          </h2>
          <p 
            style={{ color: 'var(--text-secondary)' }}
          >
            Esta página será implementada em breve
          </p>
        </div>
      </div>
    </Page>
  );
};

export default CTEsOverviewPage;
